import type { Question } from '../../engine/types';

interface Props {
  question: Question;
  value: string | undefined;
  onChange: (optionId: string) => void;
}

export default function MultiChoiceQuestion({ question, value, onChange }: Props) {
  const name = `q-${question.id}`;
  return (
    <fieldset className="space-y-3">
      <legend className="mb-2 block text-lg font-medium">{question.prompt}</legend>
      {question.helpText && <p className="text-sm text-muted">{question.helpText}</p>}
      {question.options.map((opt) => (
        <label
          key={opt.id}
          className="flex cursor-pointer items-start gap-3 rounded border border-border p-3 hover:bg-surface-alt"
        >
          <input
            type="radio"
            name={name}
            value={opt.id}
            checked={value === opt.id}
            onChange={() => onChange(opt.id)}
            className="mt-1"
          />
          <span>{opt.label}</span>
        </label>
      ))}
      {question.allowSkip && (
        <label className="flex cursor-pointer items-start gap-3 rounded border border-border p-3 hover:bg-surface-alt">
          <input
            type="radio"
            name={name}
            value="skip"
            checked={value === 'skip'}
            onChange={() => onChange('skip')}
            className="mt-1"
          />
          <span>Don't know</span>
        </label>
      )}
    </fieldset>
  );
}
